import { render, staticRenderFns } from "./already_insured.vue?vue&type=template&id=1858021a&scoped=true"
import script from "./already_insured.vue?vue&type=script&lang=js"
export * from "./already_insured.vue?vue&type=script&lang=js"
import style0 from "./already_insured.vue?vue&type=style&index=0&id=1858021a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1858021a",
  null
  
)

export default component.exports